import React, { useMemo } from "react";
import TableAction from "../../strategyProject/tabs/TabResults/TableAction/TableAction";
import { Button } from "react-bootstrap";
import style from "../../strategyProject/tabs/TabResults/TabResults.module.less";
import { getActionsModel } from "../../SPReportTabs/reportRegisterDataService";

export const PortfReportsActions = ({ props, actions, userCtx }) => {
    const { id, reportStatus } = props;
    const can = useMemo(
        () => getActionsModel(reportStatus, userCtx),
        [props, userCtx]
    );
    const isTableActionEnabled = useMemo(
        () => can.Edit || can.Approve || can.Revision,
        [can]
    );

    return (
        <>
            {
                <TableAction
                    width={"350px"}
                    data={props.data}
                    actionsDisabled={isTableActionEnabled}
                >
                    {can.Revision && (
                        <Button
                            className={style.actionTableButton}
                            onClick={() => actions.send(id)}
                            variant={"outline-warning"}
                        >
                            Отправить на доработку
                        </Button>
                    )}
                    {can.Edit && (
                        <Button
                            className={style.actionTableButton}
                            onClick={() => actions.edit(id)}
                            variant={"primary"}
                        >
                            Редактировать
                        </Button>
                    )}
                </TableAction>
            }
        </>
    );
};
